import { defineStore } from "pinia";

export const useSlickOptions = defineStore("slickOptions", {
  state: () => ({
    slickOptions: {
      slidesToShow: 1,
      autoplay: false,
      autoplaySpeed: 4000,
      arrows: true,
      dots: true,
      prevArrow: '<span type="button" class="slick-prev"><span></span></span>',
      nextArrow: '<span type="button" class="slick-next"><span></span></span>',
      pauseOnHover: true,
      lazyLoad: "ondemand",
    },
    slickBlockCollectionImage: {
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      dots: false,
      prevArrow: '<span type="button" class="slick-prev"><span></span></span>',
      nextArrow: '<span type="button" class="slick-next"><span></span></span>',
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.3,
            slidesToScroll: 2,
            dots: true
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.3,
            slidesToScroll: 1,
            dots: true
          },
        },
      ],
    },
    slickProductItemsOptions: {
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      dots: false,
      autoplaySpeed: 3000,
      variableWidth: true,
      infinite: true,
    },
    slickBlockCategoryOptions: {
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      prevArrow: '<span type="button" class="slick-prev"><span></span></span>',
      nextArrow: '<span type="button" class="slick-next"><span></span></span>',
    },
    slickBlockCategoryOptions2Column: {
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      prevArrow: '<span type="button" class="slick-prev"><span></span></span>',
      nextArrow: '<span type="button" class="slick-next"><span></span></span>',
    },
    slickBlockProductBannerOptions: {
      slidesToShow: 1,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 3000,
      prevArrow: '<span type="button" class="slick-prev"><span></span></span>',
      nextArrow: '<span type="button" class="slick-next"><span></span></span>',
      pauseOnHover: false,
    },
    slickBlockInstagram: {
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: false,
      arrows: true,
      dots: false,
      autoplaySpeed: 3000,
      variableWidth: true,
      infinite: true,
      prevArrow: '<span type="button" class="slick-prev"><span></span></span>',
      nextArrow: '<span type="button" class="slick-next"><span></span></span>',
      pauseOnHover: false,
    },

    slickBlockProductItemsOptions: {
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      dots: false,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 780,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
      prevArrow: '<span type="button" class="slick-prev"><span></span></span>',
      nextArrow: '<span type="button" class="slick-next"><span></span></span>',
      pauseOnHover: false,
    },
    slickHomePostsOptions: {
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      dots: false,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 780,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
      prevArrow: '<span type="button" class="slick-prev"><span></span></span>',
      nextArrow: '<span type="button" class="slick-next"><span></span></span>',
      pauseOnHover: false,
    },
    slickHeaderPomotionOptions: {
      slidesToShow: 1,
      autoplay: false,
      autoplaySpeed: 4000,
      vertical: true,
      arrows: false,
      dots: false,
      centerMode: false,
      centerPadding: "0px",
      prevArrow: '<span type="button" class="slick-prev"><span></span></span>',
      nextArrow: '<span type="button" class="slick-next"><span></span></span>',
      pauseOnHover: false,
      fade: true,
      cssEase: "linear",
    },
    slickBannerSlideOptions: {
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      arrows: true,
      dots: true,
      prevArrow:
        '<span type="button" class="slick-prev"><span></span></span>',
      nextArrow:
        '<span type="button" class="slick-next"><span></span></span>',
      pauseOnHover: true,
      lazyLoad: "ondemand",
    },
    slickOptionsCategory: {
      slidesToShow: 7,
      slidesToScroll: 3,
      lazyLoad: "ondemand",
      autoplay: false,
      arrows: true,
      dots: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 780,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
      prevArrow:
        '<span type="button" class="slick-prev"><span></span></span>',
      nextArrow:
        '<span type="button" class="slick-next"><span></span></span>',
      pauseOnHover: false,
    },

  }),
});
